import pt from "../../locales/pt.json";

export const tituloEspec1 = pt.especTitles.tituloEspec1;
export const tituloEspec2 = pt.especTitles.tituloEspec2;
export const tituloEspec3 = pt.especTitles.tituloEspec3;
export const tituloEspec4 = pt.especTitles.tituloEspec4;
export const tituloEspec5 = pt.especTitles.tituloEspec5;
export const tituloEspec6 = pt.especTitles.tituloEspec6;
export const tituloEspec7 = pt.especTitles.tituloEspec7;
export const tituloEspec8 = pt.especTitles.tituloEspec8;
export const tituloEspec9 = pt.especTitles.tituloEspec9;
export const tituloEspec10 = pt.especTitles.tituloEspec10;
export const tituloEspec11 = pt.especTitles.tituloEspec11;
export const tituloEspec12 = pt.especTitles.tituloEspec12;